export var version = '3.4.13';
//# sourceMappingURL=version.js.map